const ERROR_MESSAGES = {
    ELEMENT_NOT_FOUND: 'StickyButtons: Element not found',
    SCROLL_BUTTON_NOT_FOUND: 'StickyButtons: Scroll top button not found',
    INIT_FAILED: 'StickyButtons: Initialization failed'
};

const CONFIG = {
    SCROLL_THRESHOLD: 100,
    SCROLL_BEHAVIOR: 'smooth'
};

/**
 * Initialize sticky buttons functionality
 * @returns {void}
 */
const initializeStickyButtons = () => {
    const stickyButtons = document.querySelector('.widget-sticky-buttons');
    if (!stickyButtons) {
        console.warn(ERROR_MESSAGES.ELEMENT_NOT_FOUND);
        return;
    }

    try {
        const scrollTopButton = stickyButtons.querySelector('.widget-sticky-buttons__button--scroll-top');
        if (!scrollTopButton) {
            console.warn(ERROR_MESSAGES.SCROLL_BUTTON_NOT_FOUND);
            return;
        }

        /**
         * Handle scroll to top action
         * @param {Event} event - Click event
         * @returns {void}
         */
        const handleScrollToTop = (event) => {
            event.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: CONFIG.SCROLL_BEHAVIOR
            });
        };

        /**
         * Handle scroll events for widget visibility
         * @returns {void}
         */
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            stickyButtons.classList.toggle('is-visible', scrollTop > CONFIG.SCROLL_THRESHOLD);
        };

        // Add event listeners
        scrollTopButton.addEventListener('click', handleScrollToTop);
        window.addEventListener('scroll', handleScroll, { passive: true });

        // Initialize state
        handleScroll();
    } catch (error) {
        console.error(ERROR_MESSAGES.INIT_FAILED, error);
    }
};

export { initializeStickyButtons }; 